export default {
      id: "user-usage",
      viewBox: "0 0 482 512",
      url: __webpack_public_path__ + "img/svg-sprite.svg#user",
      toString: function () {
        return this.url;
      }
    }